/**
 * Created by andreyna on 6/13/2016.
 */
import BaseModelComponent from '../../base/base_model_component';
import {LAYOUT_BEHAVIOUR_CONFIG, FP_LAYOUT_STATE, FP_ANALYTICS} from './free_play_component_consts';
import _ from '../../utils/underscore';
import { IAlteredFreePlayVoucher } from './voucher/free_play_voucher_consts';

export default class FreePlayComponentModel extends BaseModelComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'FreePlayComponentModel';
    private _layoutConfig: any;
    private _direction: string;
    private _layoutState: string;
    private _analytics: any;
    private _allowOpenGameFn: any;
    private _selectedVoucher: IAlteredFreePlayVoucher;
    private _openPriority: any;
    private _height: number;
    private _gameTypeID: number;
    private _vouchers: IAlteredFreePlayVoucher[];


    /**
     *
     * @param params
     */
    init(params: any = {}) {
        super.init(params);
        if (params) {
            this._setLayoutConfig(params.layoutConfig);
            this.setDirection(params.direction)
                ._setMessageHeight(params.height)
                ._setGameTypeID(params.gameTypeID)
                ._setOpenPriority(params.openPriority)
                ._setVouchers(params.vouchers)
                .setLayoutState(params.state)
                ._setAnalytics(params.analytics)
                ._setAllowOpenGame(params.allowOpenGameFn);

        }
    }


    /**
     * Set layout behaviour
     * @param layoutConfig
     * @returns {FreePlayComponentModel}
     * @private
     */
    private _setLayoutConfig(layoutConfig) {
        this._layoutConfig = _.safeJSON(layoutConfig, LAYOUT_BEHAVIOUR_CONFIG);
        return this;
    }


    /**
     * Set initial component direction, used for PC only
     * @param direction
     * @returns {FreePlayComponentModel}
     * @private
     */
    setDirection(direction) {
        this._direction = direction;
        return this;
    }


    /**
     * Set layout state (games or vouchers)
     * @param state
     * @returns {FreePlayComponentModel}
     */
    setLayoutState(state = FP_LAYOUT_STATE.VOUCHERS) {
        this._layoutState = state;
        return this;
    }


    /**
     * Set object with analytics actions
     * @param analytics
     * @returns {FreePlayComponentModel}
     * @private
     */
    private _setAnalytics(analytics) {
        this._analytics = Object.assign({}, FP_ANALYTICS, _.safeJSON(analytics, {}));
        return this;
    }


    /**
     * Set callback that will be executed before game open. Callback should return Promise.
     * When the Promise resolved means the Game is allowed to be opened, otherwise (reject) the opening game is restricted
     * @param callback
     * @returns {FreePlayComponentModel}
     * @private
     */
    private _setAllowOpenGame(callback) {
        this._allowOpenGameFn = callback;
        return this;
    }


    /**
     * Set voucher that should be selected automatically upon opening vouchers message
     * @param voucherID
     * @private
     */
    private _setSelectedVoucher(voucherID) {
        if (_.isUndefined(voucherID) || _.isNull(voucherID) || !_.isString(voucherID)) {
            return this;
        }
        this._selectedVoucher = voucherID;
        return this;
    }


    /**
     * Set priority in order to proper close in case component has been opened in lightbox
     * @param openPriority
     * @returns {FreePlayComponentModel}
     * @private
     */
    private _setOpenPriority(openPriority) {
        this._openPriority = openPriority;
        return this;
    }


    /**
     * Set height of embedded component
     * @param height
     * @returns {FreePlayComponentModel}
     * @private
     */
    private _setMessageHeight(height) {
        this._height = !height || isNaN(parseInt(height)) || height < 500 ? 600 : height;
        return this;
    }


    /**
     * Set gameTypeID. If it exists, voucher message should be work in mode already selected game
     * @returns {FreePlayComponentModel}
     * @private
     */
    private _setGameTypeID(gameTypeID) {
        if (_.isUndefined(gameTypeID) || _.isNull(gameTypeID)) {
            return this;
        }
        this._gameTypeID = gameTypeID;
        return this;
    }


    /**
     * Set vouchers that should be presented in the current component
     * @param excludeVouchers
     * @returns {FreePlayComponentModel}
     * @private
     */
    private _setVouchers(vouchers) {
       this._vouchers = vouchers;
       return this;
    }



    /**
     * Get automatically selected voucher
     * @returns {*}
     */
    getSelectedVoucher() {
        return this._selectedVoucher;
    }


    /**
     * Set direction
     * @returns {*}
     */
    getDirection() {
        return this._direction;
    }


    /**
     * Get message embedded heigh
     * @returns {number|*}
     */
    getMessageHeight() {
        return this._height;
    }


    getGameTypeID() {
        return this._gameTypeID;
    }


    getVouchers() {
        return this._vouchers;
    }


    /**
     * Get layout config
     * @returns {undefined|*}
     */
    getLayoutConfig() {
        return this._layoutConfig;
    }


    /**
     * Get layout state Vouchers or Games
     * @returns {*}
     */
    getLayoutState() {
        return this._layoutState;
    }

    /**
     * Get priority in order to proper close in case component has been opened in lightbox
     * @returns {*}
     */
    getOpenPriority() {
        return this._openPriority;
    }


    /**
     * Get analytics actions object
     * @returns {undefined|*}
     */
    getAnalytics() {
        return this._analytics;
    }


    /**
     * Allow or avoid game opening callback
     * @returns {*}
     */
    getAllowOpenGame() {
        return this._allowOpenGameFn;
    }
}
